import Vue from "vue";
import FormWrapper from "./form-wrapper";

document.addEventListener("DOMContentLoaded", () => {
  // Form
  const formMount = document.querySelector("exhibition-history-form");
  const dataConstituentName = formMount.getAttribute("data-constituent-name");
  const dataFilteredTotal = parseInt(formMount.getAttribute("data-filtered-total"));
  const dataTotal = parseInt(formMount.getAttribute("data-total"));
  const paramBeginDate = formMount.getAttribute("param-begin-date");
  const paramConstituentId = parseInt(formMount.getAttribute("param-constituent-id")) || -1;
  const paramEndDate = formMount.getAttribute("param-end-date");
  const paramLocation = formMount.getAttribute("param-location");
  const paramMdeType = formMount.getAttribute("param-mde-type");
  const paramSearchTerm = formMount.getAttribute("param-search-term");
  const paramSortOrder = formMount.getAttribute("param-sort-order");

  // Filter/pagination
  const paginationMount = document.querySelector("[data-pagination-mount]");
  const dataFetchBaseURL = paginationMount.getAttribute("data-fetch-base-url");
  const dataLastPage = parseInt(paginationMount.getAttribute("data-last-page"));
  const dataShowMoreItemsButtonHTML = paginationMount.getAttribute('data-show-more-items-button-html');

  new Vue({
    el: formMount,
    components:{
      FormWrapper
    },
    data: {
      // Defaults not needed because router provides them, see router/calendar.
      dataConstituentName: dataConstituentName,
      dataFilteredTotal: dataFilteredTotal,
      dataTotal: dataTotal,
      paramBeginDate: paramBeginDate,
      paramConstituentId: paramConstituentId,
      paramEndDate: paramEndDate,
      paramLocation: paramLocation,
      paramMdeType: paramMdeType,
      paramSearchTerm: paramSearchTerm,
      paramSortOrder: paramSortOrder,

      // Filter/pagination
      dataFetchBaseURL: dataFetchBaseURL,
      dataLastPage: dataLastPage,
      dataShowMoreItemsButtonHTML: dataShowMoreItemsButtonHTML,
    },
    template: `
      <FormWrapper
        :dataConstituentName=dataConstituentName
        :dataFilteredTotal=dataFilteredTotal
        :dataTotal=dataTotal
        :param-begin-date=paramBeginDate
        :param-constituent-id=paramConstituentId
        :param-end-date=paramEndDate
        :param-location=paramLocation
        :param-mde-type=paramMdeType
        :param-search-term=paramSearchTerm
        :param-sort-order=paramSortOrder

        :dataFetchBaseURL=dataFetchBaseURL
        :dataLastPage=dataLastPage
        :dataShowMoreItemsButtonHTML=dataShowMoreItemsButtonHTML
      />
    `,
  });
});
